import NotContainsInterface from './ContainsInterface';
import parseArrayOfStrings from './Converter';

export default class NotContains implements NotContainsInterface {
    validate(valueToCompare: string, secondValue: Array<unknown>|string, type?: string): boolean {
        if (secondValue === undefined)
            return true

        const parsedArray = parseArrayOfStrings(valueToCompare)
        if (Array.isArray(secondValue)) {
            if (parsedArray) {
                return !parsedArray.some(item => secondValue.includes(item))
            } else if (valueToCompare) {
                return !secondValue.includes(valueToCompare.toString())
            }
        } else {
            if (parsedArray) {
                return !parsedArray.includes(secondValue)
            } else if (valueToCompare) {
                return secondValue !== valueToCompare
            }            
        }
        return true
    }
}
